import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {LovValueSummary} from '../model/lovValueSummary.model';
import {Injectable} from '@angular/core';
import {LovListSummaryConverter} from '../../../lov-list/api/model/converter/lovListSummary.converter';

@Injectable({providedIn: 'root'})
export class LovValueSummaryConverter extends HttpModelConverter<LovValueSummary>{

    protected createInstance(): LovValueSummary {
        return new LovValueSummary();
    }

    protected enrichObject(result: LovValueSummary, src: LovValueSummary) {
    }
}
